import type { VoidFunctionComponent } from 'react';
import BaseIssueItem from './BaseIssueItem';
import type { QualityIssue } from '../../../../../shared/issuesV2';
import { ignoredAtFromProjects, ignoredKindsFromProjects } from '../../../../helpers/issuesV2';
import { QUALITY_ISSUE_CONFIG } from '../../../../shared/issuesV2/issueConfig';
import { Badge } from '../../../generic';
import NonVulnerabilityIssueItemContent from './BaseIssueItem/NonVulnerabilityIssueItemContent';

type QualityIssueItemProps = {
  issue: QualityIssue;
};

/**
 * Represents a Quality issue item.
 */
const QualityIssueItem: VoidFunctionComponent<QualityIssueItemProps> = ({ issue }) => {
  const { color, icon, label } = QUALITY_ISSUE_CONFIG[issue.type] || {};
  const badge = (
    <Badge color={color} icon={icon}>
      {label}
    </Badge>
  );

  return (
    <BaseIssueItem
      id={issue.id}
      issue={issue}
    >
      <NonVulnerabilityIssueItemContent
        issue={issue}
        locator={issue.source.id}
        title={QUALITY_ISSUE_CONFIG[issue.type].title}
        createdAt={issue.createdAt}
        ignoredAt={ignoredAtFromProjects(issue.projects)}
        dependency={issue.source.name}
        version={issue.source.version}
        tickets={issue.jiraTickets}
        packageManager={issue.source.packageManager}
        depths={issue.depths}
        ignoredKinds={ignoredKindsFromProjects(issue.projects)}
        badge={badge}
     />
    </BaseIssueItem>
  );
};

export default QualityIssueItem;
